import iconRedWagon from "@/assets/alerts/extra/red-wagon.png";
import iconMatching from "@/assets/tools/icons/money.png";
import iconPractices from "@/assets/tools/icons/participate.png";

export const information = {
  "best-practices": {
    category: "information",
    name: "Best Practices",
    link: "/information/best-practices",
    thumbnail: iconPractices,
    shortDescription: "Follow these best practices to enhance your fundraising campaign",
    description: "Follow these best practices to enhance your fundraising campaign",
    show: true,
  },
  matching: {
    category: "information",
    title: "New Ways to Support a Tiltify Campaign",
    description:
      "Fundraiser talking points for encouraging employer-matching gifts and donor-advised fund donations to Tiltify campaigns.",
    name: "New Ways to Give",
    link: "/information/matching",
    thumbnail: iconMatching,
    show: true,
    shortDescription:
      "Fundraiser talking points for encouraging employer-matching gifts and donor-advised fund donations to Tiltify campaigns.",
  },
  "every-dollar-makes-a-difference": {
    category: "information",
    title: "Every Dollar Makes A Difference",
    description: "Every dollar makes a difference with St. Jude's Gifts that Give",
    name: "Every Dollar Makes A Difference",
    link: "/information/every-dollar-makes-a-difference",
    thumbnail: iconRedWagon,
    show: true,
    shortDescription: "Every dollar makes a difference with St. Jude's Gifts that Give",
  },
};
//we don't want this in the main menu
export const scheduleInfo = {
  category: "information",
  title: "St. Jude Play Live Daily Schedule",
  description: `Keep everyone up-to-date on your fundraising progress, use themed graphics on your stream, connect with chat through new interactive chatbot commands, and easily share facts about the life-saving mission of St. Jude Children's Research Hospital.`,
  name: "St. Jude Play Live Daily Schedule",
  link: "/schedule",
  thumbnail: iconRedWagon,
  show: false,
  shortDescription: `Keep everyone up-to-date on your fundraising progress, use themed graphics on your stream, connect with chat through new interactive chatbot commands, and easily share facts.`,
};
